import React, { useContext, useEffect, useState } from "react";
import useStyles from "./styles";
import { __t } from "@core/translation/translation";
import { Grid } from "@material-ui/core";
import { ColProps_2 } from "@core/utils/ColProps";
import order from "@api/order";
import TransactionsListComponent from "./TransactionsListComponent";
import { MarketContext } from "@context/MarketContext";
import { orderBookTime } from "@core/utils/IntervalApiTime";
import { useRangerOptional } from "@context/rangerContext";

const ListItemNumber = 5;

const RecentTransactionsList = ({ currencyName }) => {
  const classes = useStyles();
  const market = useContext(MarketContext);
  const ranger = useRangerOptional();
  const useWs = Boolean(ranger?.enabled);

  const [state, setState] = useState({
    sells: [],
    buys: [],
    is_fetch: false,
  });

  useEffect(() => {
    if (!useWs || !currencyName || !ranger?.subscribeMarket) return undefined;
    let cancelled = false;
    ranger.subscribeMarket(currencyName).then(() => {
      if (cancelled) return;
    });
    return () => {
      cancelled = true;
      ranger.unsubscribeMarket?.();
    };
  }, [useWs, currencyName, ranger?.subscribeMarket, ranger?.unsubscribeMarket]);

  useEffect(() => {
    if (useWs && ranger?.connected) {
      setState({
        sells: ranger.depth?.sells || [],
        buys: ranger.depth?.buys || [],
        is_fetch: Boolean(ranger.depth?.is_fetch),
      });
      return undefined;
    }

    let timerToClear = null;
    (function fetch() {
      order
        .getMarketOrderBook1({
          params: {
            market: currencyName?.replace("-", "_"),
          },
        })
        .then((data) => {
          setState((prevState) => ({
            ...prevState,
            sells: data?.content?.sells,
            buys: data?.content?.buys,
            is_fetch: true,
          }));
        })
        .catch((data) => {
          console.log(data);
        });

      timerToClear = setTimeout(fetch, orderBookTime * 1000);
    })();

    return () => clearTimeout(timerToClear);
  }, [
    currencyName,
    market.forceUpdate,
    useWs,
    ranger?.connected,
    ranger?.depth,
  ]);

  return (
    <Grid
      item
      container
      direction="row"
      className={classes.Contentcontainer}
      justify="space-evenly"
      style={{ minHeight: `calc(${(160 / 5) * ListItemNumber}px)` }}
    >
      <Grid item {...ColProps_2} className={classes.block}>
        <TransactionsListComponent
          items={state.sells?.filter((item, index) => index < ListItemNumber)}
          is_fetch={state.is_fetch}
          type="sell"
          currencyName={currencyName}
        />
      </Grid>
      <Grid item {...ColProps_2}>
        <TransactionsListComponent
          items={state?.buys?.filter((item, index) => index < ListItemNumber)}
          is_fetch={state.is_fetch}
          type="buy"
          currencyName={currencyName}
        />
      </Grid>
    </Grid>
  );
};

export default RecentTransactionsList;
